import { ref, onMounted, onUnmounted, nextTick } from 'vue';

const isActive = ref(false);
const paddingStyle = ref('0px');

/**
 * PC選單展開
 */
async function useHeaderExtend() {
  await nextTick(); // 因為 v-clock 確保 DOM 完全更新
  const header = document.querySelector('.header');
  const headerHight = header?.offsetHeight;
  // eslint-disable-next-line radix
  const headerPaddingTop = header ? parseInt(getComputedStyle(header).paddingTop, 10) : 0;

  if (document.body.id === 'page-index' && window.innerWidth >= 768) {
    if (window.scrollY > headerHight) {
      isActive.value = true;
    } else {
      isActive.value = false;
    }
  }

  if (window.innerWidth < 1200) {
    const detailBlocks = document.querySelectorAll('.detail-block');
    detailBlocks.forEach((detailBlock) => {
      detailBlock.style.top = `${headerHight + headerPaddingTop - 10}px`;
    });
  }
}

/**
 * PC選單不同寬度下調整
 */
async function useResizeList() {
  await nextTick(); // 因為 v-clock 確保 DOM 完全更新
  if (window.innerWidth < 1200) {
    const navList = document.querySelector('.nav-list');
    const actionBlock = document.querySelector('.action-block');
    if (navList && actionBlock) {
      const actionBlockWidth = actionBlock.offsetWidth;
      navList.style.width = `calc(100% - ${actionBlockWidth + 24}px)`;
    }
  }
}

/**
 * PC選單展開動畫
 */

async function useControlHeader() {
  await nextTick(); // 因為 v-clock 確保 DOM 完全更新
  const header = document.querySelectorAll('header');
  if (header.length < 1) return;

  document.querySelectorAll('.nav-name').forEach((element) => {
    // eslint-disable-next-line func-names
    element.addEventListener('mouseenter', function (e) {
      e.preventDefault();

      if (this.querySelectorAll('.detail-block').length > 0) {
        const elementHeight = this.offsetHeight;
        const elementTopPosition = this.getBoundingClientRect().top;

        document.querySelectorAll('.detail-block').forEach((block) => {
          block.style.top = `${elementHeight + elementTopPosition}px`;
        });
      }

      // 判斷螢幕寬度 > 1200 因為 769-1200 分類選單文字會斷行破版
      const detailBlock = this.querySelector('.detail-block');
      if (detailBlock) {
        const subTypeCount = this.querySelectorAll(
          '.detail-block > .detail-inner > .list-block > .detail-list',
        ).length;
        const detailBlockLeft = detailBlock.getBoundingClientRect().left + window.scrollX;
        const isTablet =
          detailBlockLeft + 110 * subTypeCount + (window.innerWidth > 1200 ? 352 : 250) + 80 >=
          window.innerWidth;
        if (isTablet) {
          detailBlock.style.right = '0px';
        }
        if (window.innerWidth > 1200) {
          detailBlock.style.right = 'unset';
        }
      }
    });
  });
}

/**
 * MB選單展開動畫
 */
function useMbBottomBar() {
  const bottomEl = document.querySelector('#bottom-more');
  bottomEl.addEventListener('click', (e) => {
    if (bottomEl) {
      const targetSelector = bottomEl.getAttribute('data-sidebar');
      const targetElement = document.querySelector(targetSelector);
      const closeBtnSelector = bottomEl.getAttribute('data-close');
      const closeBtnElement = document.querySelector(closeBtnSelector);
      const defaultTypeSelector = bottomEl.getAttribute('data-type');
      const defaultTypeElement = document.querySelector(defaultTypeSelector);
      const defaultListSelector = bottomEl.getAttribute('data-list');
      const defaultListElement = document.querySelector(defaultListSelector);

      // Toggle 'active' class on the target element and the clicked element
      if (targetElement) {
        targetElement.classList.toggle('active');
      }
      bottomEl.classList.toggle('active');

      if (bottomEl.classList.contains('active')) {
        document.querySelector('body').classList.add('lock-page');
      } else {
        document.querySelector('body').classList.remove('lock-page');
      }
      if (closeBtnElement) {
        closeBtnElement.style.display = 'inline-block';
        closeBtnElement.style.marginRight = '0px';
        closeBtnElement.style.marginLeft = '15px';
      }
      if (defaultTypeElement) {
        defaultTypeElement.classList.add('active');
      }
      if (defaultListElement) {
        defaultListElement.style.display = 'inline-block';
      }
    }
  });
}

function useMbMainSideBar() {
  document.querySelectorAll('.sidebar-main-type').forEach((element) => {
    // eslint-disable-next-line func-names
    element.addEventListener('click', function (e) {
      e.preventDefault();

      const target = this.getAttribute('data-list');

      document.querySelectorAll('.sidebar-main-type').forEach((el) => {
        el.classList.remove('active');
      });

      document.querySelectorAll('.level2-list').forEach((el) => {
        el.style.display = 'none';
      });
      this.classList.toggle('active');

      // 設定顯示的display样式为'inline-block'
      const targetElement = document.querySelector(target);
      if (targetElement) {
        targetElement.style.display = 'inline-block';
      }
    });
  });
}
function useMbMore() {
  const bottomEl = document.querySelector('#mb-more');
  bottomEl.addEventListener('click', (e) => {
    if (bottomEl) {
      const targetSelector = bottomEl.getAttribute('data-sidebar');
      const targetElement = document.querySelector(targetSelector);
      const closeBtnSelector = bottomEl.getAttribute('data-close');
      const closeBtnElement = document.querySelector(closeBtnSelector);
      const defaultTypeSelector = bottomEl.getAttribute('data-type');
      const defaultTypeElement = document.querySelector(defaultTypeSelector);
      const defaultListSelector = bottomEl.getAttribute('data-list');
      const defaultListElement = document.querySelector(defaultListSelector);

      // Toggle 'active' class on the target element and the clicked element
      if (targetElement) {
        targetElement.classList.toggle('active');
      }
      bottomEl.classList.toggle('active');

      if (bottomEl.classList.contains('active')) {
        document.querySelector('body').classList.add('lock-page');
      } else {
        document.querySelector('body').classList.remove('lock-page');
      }
      if (closeBtnElement) {
        closeBtnElement.style.display = 'inline-block';
        closeBtnElement.style.marginRight = '0px';
        closeBtnElement.style.marginLeft = '15px';
      }
      if (defaultTypeElement) {
        defaultTypeElement.classList.add('active');
      }
      if (defaultListElement) {
        defaultListElement.style.display = 'inline-block';
      }
    }
  });
}
/**
 * MB選單關閉按鈕
 */
function useMbSideBarClose() {
  const closeEl = document.querySelector('#header-close');
  closeEl.addEventListener('click', (e) => {
    const sidebarSelector = closeEl.getAttribute('data-sidebar');
    const sidebarElement = document.querySelector(sidebarSelector);
    if (sidebarElement) {
      sidebarElement.classList.remove('active');
    }
    // 重置初始狀態，確保選單在關閉時恢復
    const activeElements = document.querySelectorAll('.sidebar-main-type.active');

    activeElements.forEach((element) => {
      element.classList.remove('active');
    });

    const level2Lists = document.querySelectorAll('.level2-list');
    level2Lists.forEach((element) => {
      if (element.style.display === 'inline-block') {
        element.style.display = ''; // 清空 display 樣式，回到初始狀態
      }
    });
    document.body.classList.remove('lock-page');
    closeEl.style.display = 'none';
  });
}

function useHeaderDiffer() {
  return {
    isActive,
    paddingStyle,
    useHeaderExtend,
    useResizeList,
    useControlHeader,
    useMbBottomBar,
    useMbMainSideBar,
    useMbSideBarClose,
    useMbMore,
  };
}

export default useHeaderDiffer;
